/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Create_Book_ProjectInputs */

const en_create_book_project = /** @type {(inputs: Create_Book_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create Book Project`)
};

const es_create_book_project = /** @type {(inputs: Create_Book_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear Proyecto de Libro`)
};

const fr_create_book_project = /** @type {(inputs: Create_Book_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer un Projet de Livre`)
};

const de_create_book_project = /** @type {(inputs: Create_Book_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buchprojekt erstellen`)
};

const ja_create_book_project = /** @type {(inputs: Create_Book_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ブックプロジェクトを作成`)
};

const zh_create_book_project = /** @type {(inputs: Create_Book_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建图书项目`)
};

const ar_create_book_project = /** @type {(inputs: Create_Book_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إنشاء مشروع كتاب`)
};

const id_create_book_project = /** @type {(inputs: Create_Book_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buat Proyek Buku`)
};

const it_create_book_project = /** @type {(inputs: Create_Book_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea Progetto Libro`)
};

const ru_create_book_project = /** @type {(inputs: Create_Book_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создать Проект Книги`)
};

const pt_create_book_project = /** @type {(inputs: Create_Book_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar Projeto de Livro`)
};

const ko_create_book_project = /** @type {(inputs: Create_Book_ProjectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`책 프로젝트 생성`)
};

/**
* | output |
* | --- |
* | "Create Book Project" |
*
* @param {Create_Book_ProjectInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const create_book_project = /** @type {((inputs?: Create_Book_ProjectInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Create_Book_ProjectInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_create_book_project(inputs)
	if (locale === "es") return es_create_book_project(inputs)
	if (locale === "fr") return fr_create_book_project(inputs)
	if (locale === "de") return de_create_book_project(inputs)
	if (locale === "ja") return ja_create_book_project(inputs)
	if (locale === "zh") return zh_create_book_project(inputs)
	if (locale === "ar") return ar_create_book_project(inputs)
	if (locale === "id") return id_create_book_project(inputs)
	if (locale === "it") return it_create_book_project(inputs)
	if (locale === "ru") return ru_create_book_project(inputs)
	if (locale === "pt") return pt_create_book_project(inputs)
	return ko_create_book_project(inputs)
});